import { ApiKey, EmbeddingModel } from './index';
export function getPageParam(listType: PaginationListType): string {
    return `page[${listType.toLowerCase()}]`;
}

export enum PaginationListType {
    Users = 'Users',
    Groups = 'Groups',
    Assistants = 'Assistants',
    Models = 'Models',
    Connectors = 'Connectors',
    Knowledgebases = 'Knowledgebases',
    KnowledgebaseNewFiles = 'KnowledgebaseNewFiles',
    KnowledgebaseExistingFiles = 'KnowledgebaseExistingFiles',
    ApiKeys = 'ApiKeys',
    EmbeddingModels = 'EmbeddingModels',
    Credentials = 'Credentials',
    AuditLogFiles = 'AuditLogFiles',
    AuthLogFiles = 'AuthLogFiles',
    DlpLogFiles = 'DlpLogFiles',
    ConnectorLogFiles = 'ConnectorLogFiles',
    ScimLogFiles = 'ScimLogFiles',
    SystemLogFiles = 'SystemLogFiles',
    SecurityLogFiles = 'SecurityLogFiles',
    OpenApiConfigs = 'OpenApiConfigs',
    McpConfigs = 'McpConfigs',
    CostsPerAssistant = 'CostsPerAssistant',
    CostsPerChatModel = 'CostsPerChatModel',
    CostsPerEmbeddingModel = 'CostsPerEmbeddingModel',
    DlpTrackCountPerUser = 'DlpTrackCountPerUser',
    DlpTrackCountPerGroup = 'DlpTrackCountPerGroup',
}
